import {
  MOON_100,
  MOON_250,
  MOON_500,
  MOON_600,
  MOON_800,
  WHITE,
} from '@wandb/weave/common/css/globals.styles';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const CollectionWrapper = styled.div`
  display: flex;
  background-color: ${WHITE};
  border: 1px solid ${MOON_250};
  border-radius: 4px;
  margin-bottom: 12px;
  flex-direction: column;
`;
CollectionWrapper.displayName = 'S.CollectionWrapper';

export const Collection = styled.div`
  display: flex;
  padding: 12px 16px;
  &:hover {
    background-color: ${MOON_100};
    border-radius: 4px;
  }
  cursor: pointer;
  width: 100%;
`;
Collection.displayName = 'S.Collection';

export const CollectionExpandWrapper = styled.div`
  height: 100%;
  text-align: center;
  margin-right: 8px;
`;
CollectionExpandWrapper.displayName = 'S.CollectionExpandWrapper';

export const CollectionHeader = styled.div`
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
CollectionHeader.displayName = 'S.CollectionHeader';

export const CollectionNamePanel = styled.div`
  flex: 1 1 auto;
  display: flex;
  height: 32px;
  align-items: center;
  width: 100%;
`;
CollectionNamePanel.displayName = 'S.CollectionName';

export const CollectionEntity = styled.div`
  margin-left: -4px;
  display: flex;
`;
CollectionEntity.displayName = 'S.CollectionEntity';

export const CollectionName = styled.span`
  font-size: 20px;
  font-weight: 600;
  line-height: 32px;
  cursor: pointer;
  margin-right: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 450px;
`;
CollectionName.displayName = 'S.CollectionName';

export const CollectionTags = styled.div`
  height: 100%;
  max-width: 30%;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: auto;
`;
CollectionTags.displayName = 'S.CollectionTags';

export const CollectionActions = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  justify-content: flex-end;
`;
CollectionActions.displayName = 'S.CollectionActions';

export const CollectionOverviewIcon = styled(Icon)`
  height: 14px;
  width: 14px;
  margin-right: 4px;
`;
CollectionOverviewIcon.displayName = 'S.CollectionOverviewIcon';

export const CollectionOverviewPanel = styled.div`
  display: flex;
  margin-top: 6px;
`;

export const CollectionOverviewItem = styled.div<{hover?: boolean}>`
  display: flex;
  align-items: center;
  color: ${MOON_500};
  font-size: 14px;
  line-height: 17.6px;
  font-family: 'Source Sans Pro';
  margin-right: 16px;
  ${props =>
    props.hover
      ? `&:hover {
    color: ${MOON_800};
  }`
      : ''}
`;
CollectionOverviewItem.displayName = 'S.CollectionOverviewItem';

export const EmptyCollection = styled.div`
  padding: 24px;
  color: ${MOON_600};
`;
EmptyCollection.displayName = 'S.EmptyCollection';

export const ItemTableWrapper = styled.div`
  border-top: 1px solid ${MOON_250};
`;
